import React from 'react';
import './App.css';

import Rotas from './Routes';

const App = () => (
    <div className='App'>
      <Rotas />
    </div>
)

export default App;